import { render, staticRenderFns } from "./MyResourcesPage.vue?vue&type=template&id=a9b49918&scoped=true&lang=pug"
import script from "./MyResourcesPage.vue?vue&type=script&lang=js"
export * from "./MyResourcesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b49918",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9b49918')) {
      api.createRecord('a9b49918', component.options)
    } else {
      api.reload('a9b49918', component.options)
    }
    module.hot.accept("./MyResourcesPage.vue?vue&type=template&id=a9b49918&scoped=true&lang=pug", function () {
      api.rerender('a9b49918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/analytic-services/components/MyResourcesPage.vue"
export default component.exports